/**
 * Declarative `data-track-*` attributes for Mixpanel autocapture, fed to the
 * SDK's `autocapture.capture_extra_attrs`. Single source of truth for the
 * attribute list — keep it in sync with the attributes you author.
 *
 * See the Analytics guide (Storybook → Guides → Analytics) for how and when to
 * use these.
 */
const TRACK_DATA_ATTRIBUTES = [
  "data-track-name",
  "data-track-label",
  "data-track-context",
] as const;

export { TRACK_DATA_ATTRIBUTES };
